import React, {createContext, useEffect, useState} from "react";
import CircularProgress from "@mui/material/CircularProgress";
import {fetchAllContent} from "./api/directus";
import {defaultContent} from "./api/defaultContent";

export const ContentContext = createContext(defaultContent);

export function ContentProvider({children}) {
    const [data, setData] = useState(defaultContent);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        (async () => {
            try {
                setIsLoading(true);
                const content = await fetchAllContent();
                setData(content);
            } catch (error) {
                console.error("Error loading content:", error);
                setData(defaultContent);
            } finally {
                setIsLoading(false);
            }
        })();
    }, []);

    if (isLoading) {
        return (
            <div className="directus-loading-spinner">
                <CircularProgress size="3rem" />
            </div>
        );
    }

    return <ContentContext.Provider value={data}>{children}</ContentContext.Provider>;
}
